import React, { Fragment, useContext, useEffect, useState, forwardRef } from 'react';
import './TableValueList.css';

import {
    Paper,
    Typography,
    Select,
    MenuItem,
    Chip
} from '@material-ui/core';

import MaterialTable from 'material-table';
import { TablesContext, TableValueType } from '../TablesContext';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        width: "100%",
        overflowX: "auto",
    },
    notable: {
        padding: "16px"
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    }
});

export const TableValueList = (props) => {
    const classes = useStyles();

    const {
        state,
        isLoadingTableValues,
        addTableValue,
        updateTableValue,
        deleteTableValue
    } = useContext(TablesContext);

    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        //Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <span {...props} ref={ref} id="cancelLetter">X</span>),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        //ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <span {...props} ref={ref} id="resetSearch" /*onClick={() => {
            const tableSelected = state.tables.filter(x => x.tableDefinitionId === state.selectedTableIndex)[0]?.name;
            
            if (tableSelected === 'Customers')
                    showHideActionsButtons(state.tableValues.length, true);
        }}*/>X</span>),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
    };

    function showHideActionsButtons(amountValues, isCustomers){
        const iconsContainers = document.querySelectorAll(".MuiTableCell-paddingNone");
        
        if (iconsContainers && iconsContainers.length === amountValues){
            const searchBar = document.querySelector("input[aria-label='Search']");
            
            if (searchBar)
                searchBar.parentElement.parentElement.style.display = isCustomers ? "none" : "inline-flex";

            const actionsHeader = document.querySelector(".MuiTableCell-paddingCheckbox");

            if (actionsHeader){
                //hiding Actions header
                actionsHeader.style.display = isCustomers ? "none" : "table-cell";

                //hiding the actions to edit and delete a dimension
                for (const iconsContainer of iconsContainers)
                    iconsContainer.style.display = isCustomers ? "none" : "table-cell";
                    
                //giving some left space to values column
                const valueContainers = document.querySelectorAll(".MuiTableCell-alignLeft");
                if (valueContainers){
                    for (const valueContainer of valueContainers)
                        valueContainer.style.paddingLeft = isCustomers ? "50px" : "0px";
                }

                //hiding the action to add a new dimension
                const addIcon = document.querySelector("[title='Add']");
                if (addIcon)
                    addIcon.style.display = isCustomers ? "none" : "block";
            }
        }
        else
            setTimeout(() => showHideActionsButtons(amountValues, isCustomers), 50);
    }

    useEffect(() => {
        if (state && state.tableValues.length > 0){
            const tableSelected = state.tables.filter(x => x.tableDefinitionId === state.selectedTableIndex)[0]?.name;

            if (tableSelected === 'Customers')
                showHideActionsButtons(state.tableValues.length, true);
            else
                showHideActionsButtons(state.tableValues.length, false);
        }
    }, [state.tableValues]);

    const [tableState, setTableState] = useState({
        columns: [
            {
                title: "Domain",
                field: "domainName",
                initialEditValue: "",
                hidden: false,
                /*render: (rowData) => {
                    const table = state.tables.find(x => x.id === rowData.id)?.relatedTable;
                    if (table !== -1) {
                        return rowData.domainName;
                    } else {
                        return (<Typography></Typography>);
                    }
                },*/
                editComponent: (props) => {
                    //const { data } = props.columnDef.lookup;
                    const { data } = props.columnDef.test;
                    return (
                        <>
                            {(props.columnDef.test.length > 0) ?
                                <Select
                                    className={classes.select}
                                    value={props.value || props.columnDef.initialEditValue}
                                    multiple={false}
                                    renderValue={selected => {
                                        if (!Array.isArray(selected))
                                            selected = [selected];

                                        //todo: why index and domain are in the same paramenter?
                                        if (!isNaN(selected[0])) {
                                            return ( //numeric index
                                                <div className={classes.chips}>
                                                    {
                                                        selected.map((id, index) => (
                                                            <Chip key={index} label={props.columnDef.test.find(x => x.valueId === id)?.text} className={classes.chip} />
                                                        ))
                                                    }
                                                </div>
                                            )
                                        }
                                        else {
                                            return (
                                                <div className={classes.chips}>
                                                    {
                                                        selected.map((domainName, index) =>
                                                            <Chip
                                                                key={index}
                                                                label={props.columnDef.test.find(x => x.text === domainName)?.text}
                                                                className={classes.chip}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            )
                                        }
                                    }}
                                    onChange={event => props.onChange(event.target.value)}
                                >
                                    {
                                        props.columnDef.test.length > 0 &&
                                        props.columnDef.test.map((item, index) =>
                                            <MenuItem
                                                key={index}
                                                value={item.valueId}
                                            >
                                                {item.text}
                                            </MenuItem>
                                    )}
                                </Select>
                                :
                                <Typography>
                                    No values available
                                </Typography>
                            }
                        </>
                    );
                }
            },
            {
                title: "Customer",
                field: "customerName",
                initialEditValue: "",
                hidden: false,
                /*render: (rowData) => {
                    const table2 = state.tables.find(x => x.id === rowData.id)?.relatedTable;
                    if (table2 !== -1) {
                        let parentValue = null;
                        let index = 0;
                        return (
                            <div className={classes.chips}>
                                {
                                    rowData &&
                                    rowData.relatedValuesIds &&
                                    rowData.relatedValuesIds[0] &&
                                    table2 &&
                                    table2.childValues &&
                                    table2.childValues.length > 0 &&
                                    table2.childValues.map(parent => {
                                        if (parent.id == rowData.relatedValuesIds[0])
                                            parentValue = parent.value;
                                    }) &&
                                    <Chip key={index++} label={parentValue} className={classes.chip} />
                                }
                            </div>
                        );
                    } else {
                        return (<Typography></Typography>);
                    }
                },*/
                editComponent: (props) => {
                    //let { data } = props.columnDef.lookup;
                    let { data } = props.columnDef.testCustomer;
                    return (
                        <>
                            {
                                props.columnDef.testCustomer.length > 0 ?
                                <Select
                                    className={classes.select}
                                    value={props.value || props.columnDef.initialEditValue}
                                    multiple={false}
                                    renderValue={selected => {
                                        if (!Array.isArray(selected))
                                            selected = [selected];
                                        //todo: why index and domain are in the same paramenter?
                                        if (!isNaN(selected[0])) {
                                            return ( //numeric index
                                                <div className={classes.chips}>
                                                    {
                                                        selected.map((id, index) =>
                                                            <Chip
                                                                key={index}
                                                                label={props.columnDef.testCustomer.find(x => x.valueId === id)?.text}
                                                                className={classes.chip}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            )
                                        }
                                        else {
                                            return ( //customer name
                                                <div className={classes.chips}>
                                                    {
                                                        selected.map((customerName, index) =>
                                                            <Chip
                                                                key={index}
                                                                label={props.columnDef.testCustomer.find(x => x.text === customerName)?.text}
                                                                className={classes.chip}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            )
                                        }
                                    }}
                                    onChange={event => props.onChange(event.target.value)}
                                >
                                    {
                                        props.columnDef.testCustomer.length > 0 &&
                                        props.columnDef.testCustomer.map((item, index) =>
                                            <MenuItem
                                                key={index}
                                                value={item.valueId}
                                            >
                                                {item.text}
                                            </MenuItem>
                                    )}
                                </Select>
                                :
                                <Typography>
                                    No values available
                                </Typography>
                            }
                        </>
                    );
                }
            },
            {
                title: "Value",
                field: "value"
            },
            {
                title: "Custom Id",
                field: "customId",
                hidden: false
            },
            {
                title: "Code",
                field: "code",
                hidden: false
            },
            {
                title: "External Key",
                field: "externalKey",
                hidden: props.tableValueType === TableValueType.Local
            }
        ],

        data: [].concat(state.tableValues)
    });

    useEffect(() => {
        if (state.selectedTableIndex !== -1) {
            setTableState(prevState => {
                // Customize what columns we want to show
                const columns = [].concat(prevState.columns);
                
                if (state.tables && state.tables.length > 0) {
                    let table = state.tables[state.selectedTableIndex];
                    // Check if the current table has related tables associated to it
                    // If that is the case, create the column.lookup object
                    // That lookup will be used to fill the relatedValuedIds value

                    // hide/display the unnecessary columns
                    if (table.name !== 'SubDomains')
                        columns[columns.findIndex(x => x.field === 'domainName')].hidden = true;
                    
                    if (table.name !== 'SubCustomers')
                        columns[columns.findIndex(x => x.field === 'customerName')].hidden = true;
                    
                    if (table.name !== 'Rebillings' && table.name !== 'Release Dates')
                        columns[columns.findIndex(x => x.field === 'customId')].hidden = true;
                    else
                        columns[columns.findIndex(x => x.field === 'customId')].hidden = false;
                    
                    if (table.name !== 'Controlling Areas')
                        columns[columns.findIndex(x => x.field === 'code')].hidden = true;
                    else
                        columns[columns.findIndex(x => x.field === 'code')].hidden = false;

                    if (table.name === "SubDomains"){
                        const columnRltdId = columns.find(x => x.field === "domainName");
                        const hasRelatedTables = table.relatedTable !== null;
                        // Show the column
                        columnRltdId.hidden = !hasRelatedTables;
                        // Set initial value
                        columnRltdId.initialEditValue = table.hasMultipleRelatedValues ? [] : "";
                        // Create the lookup object
                        if (hasRelatedTables) {
                            const relatedTable = state.tables.find(x => x.name === table.relatedTable.name);
                            let lookup = {};
                            if (relatedTable) {
                                const data = { tableId: relatedTable.id, name: relatedTable.name, values: [] };
                                relatedTable.childValues.forEach(x =>
                                    data.values.push({ valueId: x.id, text: x.value })
                                );
                                lookup.data = data;
                            }
                            
                            columnRltdId.test = lookup.data.values;
                            //columnRltdId.lookup = lookup;
                        }
                    }
                    if (table.name === "SubCustomers"){
                        const columnRltdId2 = columns.find(x => x.field === "customerName");
                        const hasRelatedTables2 = table.relatedTable !== null;
                        // Show the column
                        columnRltdId2.hidden = !hasRelatedTables2;
                        // Set initial value
                        columnRltdId2.initialEditValue = table.hasMultipleRelatedValues ? [] : "";
                        // Create the lookup object
                        if (hasRelatedTables2) {
                            const relatedTable2 = state.tables.find(x => x.name === table.relatedTable.name);
                            let lookup2 = {};
                            if (relatedTable2) {
                                const data2 = { tableId: relatedTable2.id, name: relatedTable2.name, values: [] };
                                relatedTable2.childValues.forEach(x => {
                                    data2.values.push({ valueId: x.id, text: x.value });
                                });
                                lookup2.data = data2;
                            }
                            columnRltdId2.testCustomer = lookup2.data.values;
                            //columnRltdId2.lookup = lookup2;
                        }
                    }
                }

                if (document.querySelector(".MuiTableCell-alignLeft")){
                    const allColumns = document.querySelectorAll(".MuiTableCell-alignLeft");
                    for (let i = 0; i < allColumns.length; i++)
                        allColumns[i].style.width = "42.5%";
                }

                return {
                    ...prevState,
                    column: columns,
                    data: [].concat(state.tableValues)
                }
            });
        }
    }, [state.tables, state.selectedTableIndex, state.tableValues]);

    useEffect(() => {
        if (document.querySelector('#cancelLetter'))
            document.querySelector('#cancelLetter').click();

        if (document.querySelector('#resetSearch'))
            document.querySelector('#resetSearch').click();
    }, [state.selectedTableIndex]);

    return (
        <Fragment>
            {state.selectedTableIndex !== -1 ?
                <MaterialTable
                    isLoading={isLoadingTableValues}
                    title="Table values"
                    icons={tableIcons}
                    columns={tableState.columns}
                    data={tableState.data}
                    options={{
                        paging: false,
                        addRowPosition: 'first'
                    }}
                    editable={{
                        onRowAdd: async (newData) => {
                            let domainObjects = [];
                            let customerObjects = [];
                            if (state && state.tables && state.tables.length > 0){
                                const allTables = state.tables;
                                allTables.map(table => {
                                    if (table.name === "Domains")
                                        domainObjects = table.childValues;

                                    if (table.name === "Customers")
                                        customerObjects = table.childValues;
                                });
                            }

                            const table = state.tables[state.selectedTableIndex];
                            await addTableValue(
                                {
                                    ...newData,
                                    parentDomains: domainObjects,
                                    parentCustomers: customerObjects,
                                    tableName: table.name,
                                    relatedValueIds: table.relatedTable ? Array.isArray(newData.relatedValueIds) ? newData.relatedValueIds : [newData.relatedValueIds] : null
                                }
                            );
                        },
                        onRowUpdate: async (newData, oldData) => {
                            const table = state.tables[state.selectedTableIndex];
                            await updateTableValue(
                                {
                                    ...newData,
                                    relatedValueIds: table.relatedTable ? Array.isArray(newData.relatedValueIds) ? newData.relatedValueIds : [newData.relatedValueIds] : null

                                }
                            );
                        },
                        onRowDelete: async (oldData) => {
                            const oldTable = state.tables[state.selectedTableIndex];
                            await deleteTableValue(oldTable, oldData.id);
                        }

                    }}
                />
                :
                <Paper className={classes.notable}>
                    <Typography variant="h6">
                        No table selected.
                    </Typography>
                    <Typography variant="body1">
                        Select a table from the list to see what values are stored.
                    </Typography>
                </Paper>
            }
        </Fragment>
    );
}